<template>
  <div>
    <h3>{{ $t('randevu.upcoming.title') }}</h3>

    <div v-if="loading"  class="info">{{ $t('common.loading') }}</div>
    <div v-else-if="error" class="error">{{ error }}</div>

    <ul v-else class="list">
      <li v-for="a in appts" :key="a.id">
        <span class="time">{{ formatHourMinute(a.start_time) }}</span>
        <strong>{{ a.customer_name }}</strong>
        &nbsp;→&nbsp;
        <em>{{ a.expert_name }}</em>
        <small>({{ a.status_tr || a.status }})</small>
        <ul class="svc">
          <li v-for="s in a.services" :key="s.service_id">
            {{ s.service_name }} ×{{ s.quantity }}
          </li>
        </ul>
      </li>
      <li v-if="!appts.length">{{ $t('randevu.upcoming.empty') }}</li>
    </ul>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import axios from "axios";

const { t } = useI18n();

const appts   = ref([]);
const loading = ref(false);
const error   = ref(null);

const fetch = async () => {
  loading.value = true;
  try {
    const { data } = await axios.get("/promo/user/appointments/upcoming-today");
    appts.value = data;
  } catch {
    error.value = t("randevu.upcoming.fetch_error");
  } finally {
    loading.value = false;
  }
}; 

onMounted(fetch);
</script>

<style scoped>
.list   { margin: 0;  padding: 0; list-style: none; }
.list>li{ margin: .4rem 0; }
.time   { font-family: monospace; margin-right: .4rem; }
.svc    { margin: .2rem 0 .4rem 2rem; list-style: square; font-size: .9em; }
.info,.error{ margin-top: .6rem; }
.error { color:#f44336; }
</style>
